import React from "react";
import './App.css';
import Navbar from "./Components/Navbar/Navbar";
import Home from "./Components/Home/home";
import Main from "./Components/Main/Main";
import Footer from "./Components/Footer/Footer";
const App = ()=>{
  return(
    <>
    <Navbar/>
    <Home/>
    <Main/>
    <Footer/>

    </>
  )
}

export default App;